import type { ReactNode } from 'react'

import { ModuleAccessRoute } from '@/lib/app/module-access-route'
import { useFeatureFlagEnabled } from '@/lib/config/featureflag'

export const AIGovernanceModuleRoute = ({ children }: { children: ReactNode }) => {
  const { isEnabled, isLoading } = useFeatureFlagEnabled('ai-governance')
  return (
    <ModuleAccessRoute hasAccess={isEnabled} isLoading={isLoading}>
      {children}
    </ModuleAccessRoute>
  )
}
